import styled from 'styled-components';
import { Box } from './containers';

export const EmptyState = styled(Box)`
  border: 2px dashed ${({ theme }) => theme.colors.accentGray04};
  border-radius: 4px;
  height: 75%;
  margin: 12px 0;
`;
